<template>
  <Button
    v-if="!isEditMode"
    plain
    color="grey"
    data-tourid="problemSolving-5WhysTool-close"
    :text="$t('common.button.close')"
    @click="$emit('close')"
  />
  <div v-else>
    <template v-if="currentStep === steps.QUESTIONS && isEditMode">
      <Button
        plain
        color="grey"
        class="me-2"
        data-tourid="problemSolving-5WhysTool-cancel"
        :text="$t('common.button.cancel')"
        @click="$emit('close')"
      />
      <Button
        color="primary"
        data-tourid="problemSolving-5WhysTool-next"
        :disabled="!canGoToNextStep"
        :text="$t('common.next')"
        @click="$emit('next')"
      />
    </template>
    <template v-if="currentStep === steps.SUMMARY && isEditMode">
      <Button
        plain
        color="grey"
        class="me-2"
        data-tourid="problemSolving-5WhysTool-back"
        :text="$t('common.button.back')"
        @click="$emit('back')"
      />
      <Button
        color="primary"
        data-tourid="problemSolving-5WhysTool-finish"
        :text="$t('common.button.finish')"
        @click="$emit('finish')"
      />
    </template>
  </div>
</template>
<script>
import Button from '@/components/UI/Button'
export default {
  name: 'FiveWhysToolActions',
  components: {
    Button,
  },
  props: {
    isEditMode: {
      required: true,
      type: Boolean,
    },
    currentStep: {
      required: true,
      type: String,
    },
    steps: {
      required: true,
      type: Object,
    },
    canGoToNextStep: {
      required: true,
      type: Boolean,
    },
  },
}
</script>
